import { useContext, useEffect } from "react";

import MapContext from "../map/MapContext";

import olMap from "ol/Map";
import { Zoom } from "ol/control";

/**
 * Component to register the OL ZoomButtons control on the Map
 * using the MapContext.
 * @component
 * @example
 * <Map center={center} zoom={zoom} projection={Epsg27700}>
 *   ...
 *   <Controls>
 *     <ZoomButtons />
 *   </Controls>
 * </Map>
 */
const ZoomButtons = () => {
  const map = useContext(MapContext) as olMap;

  useEffect(() => {
    if (!map) return () => {};

    const control = new Zoom();
    map.addControl(control);

    return () => {
      if (!map) return;
      map.removeControl(control);
    };
  }, [map]);

  return null;
};

export default ZoomButtons;
